"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aboutTaxi = void 0;
exports.aboutTaxi = {
    aboutTaxi_title: "Об Эко-такси",
    aboutTaxi_name: "Эко-такси",
    aboutTaxi_text1: "Эко-такси — это бесплатный проект, который занимается вывозом малых объёмов вторсырья у жителей города Иваново.",
    aboutTaxi_text2: "Вывоз осуществляется в рамках реализации гранта от ",
    aboutTaxi_text3: ", при поддержке ",
    aboutTaxi_voop: 'Ивановского областного отделения "Всероссийского общества охраны природы"',
    aboutTaxi_rosMolod: 'Федерального агентства по делам молодёжи "Росмолодёжь"',
    aboutTaxi_order: "Вызвать Эко-такси",
    aboutTaxi_phone: "Номер телефона эко-такси",
};
//# sourceMappingURL=aboutTaxi.js.map